<div class="d-inline-block position-relative">
  @if (keyword.type === keywords.CALLS_PLACED_OR_RECEIVED) {
    <ng-select
      [attr.data-automation]="'expression-keyword-direction'"
      [placeholder]="keyword.type | translate"
      [(ngModel)]="keyword.keywordValue.value"
      [items]="keyword.choices"
      [clearable]="false"
      [searchable]="false"
      (ngModelChange)="handleModelChange()"
      bindLabel="selection"
      bindValue="value"
      class="expression-keyword__dropdown"
    ></ng-select>
  }
  @if (keyword.type === keywords.EXTENSION_USERNAME_OR_DEVICENAME) {
    <span
      class="expression-keyword"
      popoverClass="keyword-popover"
      data-automation="expression-keyword-input-toggle"
      [ngbPopover]="inputtemplate"
      [autoClose]="'outside'"
      [placement]="'bottom'"
      [ngClass]="{
        'expression-keyword--error': keyword.hasError,
      }"
      (hidden)="handlePopoverClose()"
    >
      {{ inputTemplatePlaceholder | translate }}
    </span>
  }
  @if (keyword.type === keywords.FROM_DATE) {
    <div class="p-field">
      @if (keyword.keywordValue?.value) {
        <label
          data-automation="expression-keyword-from-label"
          class="expression-keyword mb-0"
          [attr.for]="'fromDate'"
          [ngClass]="{ 'expression-keyword--error': keyword.hasError }"
        >
          {{ keyword.keywordValue?.value | date: 'MM/dd/yy' }}
        </label>
      }
      @if (!keyword.keywordValue?.value) {
        <label
          data-automation="expression-keyword-from-label"
          class="expression-keyword expression-keyword--empty mb-0"
          [attr.for]="'fromDate'"
        >
          {{ keyword.type | translate }}
        </label>
      }
      <p-datepicker
        [attr.data-automation]="'expression-keyword-from'"
        [(ngModel)]="keyword.keywordValue.value"
        (ngModelChange)="handleModelChange()"
        inputId="fromDate"
        panelStyleClass="keyword-datepicker"
        inputStyleClass="keyword-datepicker-input"
        [@.disabled]="true"
        [baseZIndex]="9999"
      ></p-datepicker>
    </div>
  }
  @if (keyword.type === keywords.TO_DATE) {
    <div class="p-field">
      @if (keyword.keywordValue?.value) {
        <label
          data-automation="expression-keyword-to-label"
          class="expression-keyword mb-0"
          [attr.for]="'toDate'"
          [ngClass]="{ 'expression-keyword--error': keyword.hasError }"
        >
          {{ keyword.keywordValue?.value | date: 'MM/dd/yy' }}
        </label>
      }
      @if (!keyword.keywordValue?.value) {
        <label
          data-automation="expression-keyword-to-label"
          class="expression-keyword expression-keyword--empty mb-0"
          [attr.for]="'toDate'"
        >
          {{ keyword.type | translate }}
        </label>
      }
      <p-datepicker
        [attr.data-automation]="'expression-keyword-to'"
        [(ngModel)]="keyword.keywordValue.value"
        (ngModelChange)="handleModelChange()"
        panelStyleClass="keyword-datepicker"
        inputStyleClass="keyword-datepicker-input"
        inputId="toDate"
        [@.disabled]="true"
        [baseZIndex]="9999"
      ></p-datepicker>
    </div>
  }
  <ng-template #inputtemplate>
    <div class="p-2">
      <label class="form-label" [attr.for]="'input-dropdown'">
        {{ 'tkey;reports.call_logs.keyword.input.selection.label' | translate }}
      </label>
      <ng-select
        [attr.data-automation]="'input-selection'"
        [placeholder]="'Extension/username/device name'"
        [items]="keyword.choices"
        [clearable]="false"
        [searchable]="false"
        [labelForId]="'input-dropdown'"
        [(ngModel)]="keyword.keywordValue.selection"
        (ngModelChange)="handleSelectionChange()"
        bindLabel="selection"
        bindValue="value"
        class="input-dropdown"
      ></ng-select>
      @if (keyword.keywordValue.selection) {
        <div class="mt-3">
          <div>
            <label class="form-label" [attr.for]="'textfield-input'">
              {{
                'tkey;reports.call_logs.keyword.input.value.label'
                  | translate
                    : {
                        searchValue:
                          keyword.keywordValue.selection === 'extension'
                            ? 'an extension'
                            : 'a ' + keyword.keywordValue.selection,
                      }
              }}
            </label>
          </div>
          <div>
            @if (keyword.keywordValue.selection === 'extension') {
              <ziro-expression-editor-keyword-extension-search
                [entity]="
                  keyword.keywordValue?.value
                    ? { extensionUsernameOrDeviceName: { value: keyword.keywordValue?.value } }
                    : null
                "
                (ziroFormsUpdate$)="handleInputChange($event)"
                class="keyword-search"
              ></ziro-expression-editor-keyword-extension-search>
            }
            @if (keyword.keywordValue.selection === 'username') {
              <ziro-expression-editor-keyword-username-search
                [entity]="
                  keyword.keywordValue?.value
                    ? { extensionUsernameOrDeviceName: { value: keyword.keywordValue?.value } }
                    : null
                "
                (ziroFormsUpdate$)="handleInputChange($event)"
                class="keyword-search"
              ></ziro-expression-editor-keyword-username-search>
            }
            @if (keyword.keywordValue.selection === 'device') {
              <ziro-expression-editor-keyword-device-search
                [entity]="
                  keyword.keywordValue?.value
                    ? { extensionUsernameOrDeviceName: { value: keyword.keywordValue?.value } }
                    : null
                "
                (ziroFormsUpdate$)="handleInputChange($event)"
                class="keyword-search"
              ></ziro-expression-editor-keyword-device-search>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
</div>
